<script lang="ts">
	import ExampleOne from './_examples/example-one.svelte';
	import ExampleThree from './_examples/example-three.svelte';
	import ExampleTwo from './_examples/example-two.svelte';
</script>

<div
	id="meeko-desktop-gui"
	class="relative flex h-[850px] w-full flex-col items-center justify-center gap-12"
>
	<div
		class="fade-bottom relative flex h-full w-full items-center justify-center overflow-x-hidden overflow-y-hidden sm:overflow-x-auto"
	>
		<ExampleThree
			class="absolute left-28 top-56 z-20 hidden -rotate-6 transition-all duration-300 hover:left-20 hover:top-32 hover:-rotate-12 lg:flex"
		/>
		<ExampleOne class="absolute top-12 z-30 transition-all duration-300 lg:hover:top-0" />
		<ExampleTwo
			class="absolute right-28 top-40 z-20 hidden rotate-3 transition-all duration-300 hover:right-12 hover:top-24 hover:rotate-6 lg:flex"
		/>
	</div>
	<div class="flex w-full flex-col items-center justify-center gap-6">
		<div class="flex flex-col items-center justify-center gap-3">
			<p class="max-w-sm text-center text-xs italic text-lightTertiary"></p>
			<p class="max-w-xl text-center text-lightSecondary">
				Meeko always answers using the latest data and patch information.{' '}<br
					class="hidden sm:block"
				/>Join our community of 4000+ gamers today and start your next journey ✨
			</p>
		</div>
	</div>
</div>
